'use client';

import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { useSyncExternalStore } from './useSyncExternalStore.esm.js';
import { parseMutationFilterArgs, notifyManager } from '@tanstack/query-core';
import { useQueryClient } from './QueryClientProvider.esm.js';

function useIsMutating(arg1, arg2, arg3) {
  var _parseMutationFilterA = parseMutationFilterArgs(arg1, arg2, arg3),
      _parseMutationFilterA2 = _slicedToArray(_parseMutationFilterA, 2),
      filters = _parseMutationFilterA2[0],
      _parseMutationFilterA3 = _parseMutationFilterA2[1],
      options = _parseMutationFilterA3 === void 0 ? {} : _parseMutationFilterA3;

  var queryClient = useQueryClient({
    context: options.context
  });
  var mutationCache = queryClient.getMutationCache();
  return useSyncExternalStore(React.useCallback(function (onStoreChange) {
    return mutationCache.subscribe(notifyManager.batchCalls(onStoreChange));
  }, [mutationCache]), function () {
    return queryClient.isMutating(filters);
  }, function () {
    return queryClient.isMutating(filters);
  });
}

export { useIsMutating };